// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6987777","239":"d300092b","455":"ee70d17e"}[chunkId] + ".chunk.js";
};